export function saveProduct(product) {
    sessionStorage.setItem('product', JSON.stringify(product));
}

export function getProduct() {
    const product = sessionStorage.getItem('product');
    return product ? JSON.parse(product) : null;
}